<template>
	<div>
		<div style="margin:15px 0">
			<!-- 面包屑 -->
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/couponPackage' }">券包管理</el-breadcrumb-item>
				<el-breadcrumb-item v-if="type===0" :to="{ path: '/scenicList' }">景区列表</el-breadcrumb-item>
				<el-breadcrumb-item v-if="type===0" :to="{ path: '/coupons' }">券包设置</el-breadcrumb-item>
				<el-breadcrumb-item>通用优惠券设置</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<el-form :rules="rules" :model="formList" ref="formList">
			<el-card class="box-card">
				<el-form-item label="批次归属商户号" prop="belong_merchant" label-width="120px">
					<el-input style="width: 200px" v-model="formList.belong_merchant" placeholder="请输入批次归属商户号"></el-input>
				</el-form-item>
<!--				<el-form-item label="批次类型" :rules="rules.must" label-width="120px">-->
<!--					<template>-->
<!--						<el-select v-model="formList.stock_type" filterable-->
<!--								   @change="stockSelect">-->
<!--							<el-option label="固定面额满减券批次" value="NORMAL"/>-->
<!--							<el-option label="折扣券批次" value="DISCOUNT"/>-->
<!--							<el-option label="换购券批次" value="EXCHANGE"/>-->
<!--						</el-select>-->
<!--					</template>-->
<!--				</el-form-item>-->
			</el-card>
			<el-card class="box-card">
				<h4>券可核销时间</h4>
				<el-form-item label="开始时间" prop="coupon_use_rule.coupon_available_time.available_begin_time">
					<el-date-picker
							v-model="t1"
							type="datetime"
							placeholder="选择日期时间"
							@change="changeTime"
							value-format="yyyy-MM-dd HH:mm:ss"
							default-time="12:00:00">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="结束时间" prop="coupon_use_rule.coupon_available_time.available_end_time">
					<el-date-picker
							v-model="t2"
							type="datetime"
							placeholder="选择日期时间"
							@change="changeTime2"
							value-format="yyyy-MM-dd HH:mm:ss"
							default-time="12:00:00">
					</el-date-picker>
				</el-form-item>
			</el-card>
			<el-card class="box-card">
				<h4>核销规则</h4>
				<el-form-item label="核销方式" :rules="rules.must" label-width="100px">
					<template>
						<el-select v-model="formList.coupon_use_rule.use_method" filterable
								   @change="changeMethod">
							<el-option label="线下扫码核销" value="OFF_LINE"/>
							<el-option label="线上小程序核销" value="MINI_PROGRAMS"/>
							<el-option label="微信支付付款码核销" value="PAYMENT_CODE"/>
							<el-option label="用户自助核销" value="SELF_CONSUME"/>
						</el-select>
					</template>
				</el-form-item>
				<el-form-item v-if="formList.coupon_use_rule.use_method==='MINI_PROGRAMS'" label="小程序appid"
							 prop="stock_send_rule.mini_programs_appid" label-width="100px">
					<el-input style="width: 200px" v-model="formList.stock_send_rule.mini_programs_appid"></el-input>
				</el-form-item>
				<el-form-item v-if="formList.coupon_use_rule.use_method==='MINI_PROGRAMS'" label="小程序path"
							 prop="stock_send_rule.mini_programs_path" label-width="100px">
					<el-input style="width: 80%" v-model="formList.stock_send_rule.mini_programs_path"></el-input>
				</el-form-item>
			</el-card>
			<el-card class="box-card">
				<h4>发放规则</h4>
				<el-form-item label="券最大发放个数：" :rules="rules.must" label-width="165px">
          <el-input-number v-model.number="formList.stock_send_rule.max_coupons" style="width: auto" :min="1" :max="1e10" placeholder="请输入数量"></el-input-number>
				</el-form-item>
				<el-form-item label="单用户最大可领个数：" :rules="rules.must" label-width="165px">
          <el-input-number v-model.number="formList.stock_send_rule.max_coupons_per_user" style="width: auto" :min="1" :max="1e2" placeholder="请输入数量"></el-input-number>
				</el-form-item>
				<el-form-item label="单天发放上限个数：" label-width="165px" v-show="formList.coupon_use_rule.use_method!==''">
          <el-input style="width:200px" min="1" max="1e10" type="number"
                    v-model.number="formList.stock_send_rule.max_coupons_by_day"
                    placeholder="请输入数量"></el-input>
<!--          <el-input-number v-model.number="formList.stock_send_rule.max_coupons_by_day" style="width: auto" :min="1" :max="1e10" placeholder="请输入数量"></el-input-number>-->
				</el-form-item>
			</el-card>
			<el-card>
<!--				<el-form-item label="商户单据号：" label-width="140px">-->
<!--					<el-input style="width: 80%" v-model="formList.out_request_no"></el-input>-->
<!--				</el-form-item>-->
				<el-form-item label="券code模式：" label-width="140px">
					<template>
						<el-select v-model="formList.coupon_code_mode" filterable
								   @change="stockSelect">
							<el-option label="系统分配券code" value="WECHATPAY_MODE"/>
							<el-option label="商户发放时接口指定券code" value="MERCHANT_API"/>
							<el-option label="商户上传自定义code" value="MERCHANT_UPLOAD"/>
						</el-select>
					</template>
				</el-form-item>
<!--				<el-form-item label="事件通知配置：" label-width="140px">-->
<!--					<el-input style="width: 80%" v-model="formList.packageName"></el-input>-->
<!--				</el-form-item>-->
<!--				<el-form-item label="是否允许营销补贴：" label-width="140px">-->
<!--					<el-radio-group v-model="formList.subsidy">-->
<!--						<el-radio :label="true">是</el-radio>-->
<!--						<el-radio :label="false">否</el-radio>-->
<!--					</el-radio-group>-->
<!--				</el-form-item>-->
			</el-card>
<!--			<el-card class="box-card">-->
<!--				<h4>事件通知配置</h4>-->
<!--				<el-form-item label="事件通知appid：">-->
<!--					<el-input style="width: 80%" v-model="formList.notify_config.notify_appid" disabled></el-input>-->
<!--				</el-form-item>-->
<!--			</el-card>-->
			<el-card class="box-card">
				<h4>样式信息</h4>
				<el-form-item label="商户logo：">
					<el-upload class="avatar-uploader"
							   :action="wxImage"
							   :show-file-list="false"
							   :on-success="upLoadSuccessLogo">
						<img v-if="formList.display_pattern_info.merchant_logo_url"
							 :src="formList.display_pattern_info.merchant_logo_url" class="avatar" alt="">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="商户名称：">
					<el-input style="width: 80%" v-model="formList.display_pattern_info.merchant_name"></el-input>
				</el-form-item>
			</el-card>
		</el-form>
		<span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="save">保 存</el-button></span>
	</div>
</template>

<script>
import qs from "qs";
import {wxImage} from "../axios/index";
import coupon from "../api/coupons";

export default {
	props: {
		pageSize: {
			type: Number,
			default: 10,
		}
	},
	data() {
		return {
			wxImage,
			t1: '',
			t2: '',
			id: '',
			dialogImageUrl: "",
			dialogVisible: false,
			formList: {
				belong_merchant: '',//批次归属商户号
				comment: undefined,//批次备注
				// stock_type: 'NORMAL',//批次类型
				coupon_use_rule: {//核销规则
					coupon_available_time: {//券可核销时间
						available_begin_time: '',
						available_end_time: '',
					},
					// fixed_normal_coupon: {//固定面额满减券使用规则
					// 	discount_amount: undefined,//优惠金额
					// 	transaction_minimum: undefined,//消费门槛
					// },
					// discount_coupon: {//折扣券使用规则
					// 	discount_percent: undefined,//折扣比例
					// 	transaction_minimum: undefined,//消费门槛
					// },
					// exchange_coupon: {//换购券使用规则
					// 	exchange_price: undefined,//单品换购价
					// 	transaction_minimum: undefined,//消费门槛
					// },
					use_method: 'OFF_LINE',//核销方式
					mini_programs_appid:undefined,
					mini_programs_path:undefined,
				},
				stock_send_rule: {//发放规则
					max_coupons: 10,//批次最大发放个数
					max_coupons_per_user: 1,//用户最大可领个数
					max_coupons_by_day: undefined//
				},
				coupon_code_mode: 'WECHATPAY_MODE',//券code模式
				display_pattern_info: {//样式信息
					merchant_logo_url: undefined,
					merchant_name: undefined,
				},
				// notify_config: {//事件通知配置
				// 	notify_appid: 'wx85b5c483bf957d25'//事件通知appid
				// },
				out_request_no:undefined,//商户单据号
				subsidy: false,//是否允许营销补贴
			},
			rules: {
				belong_merchant: [{required: true, min: 8, max: 15, message: '批次归属商户号8~15字符', trigger: 'blur'},],
				comment: [{required: false, min: 1, max: 20, message: '批次备注最长20字符', trigger: 'blur'},],
				goods_name: [{required: true, min: 1, max: 15, message: '适用商品范围1~15字符', trigger: 'blur'},],
				must: [{required: true, message: '请输入', trigger: 'blur'}],
				'coupon_use_rule.coupon_available_time.available_begin_time': [{
					required: true,
					message: '请选择开始日期',
					trigger: 'blur'
				}],
				'coupon_use_rule.coupon_available_time.available_end_time': [{
					required: true,
					message: '请选择结束日期',
					trigger: 'blur'
				}],
				'stock_send_rule.mini_programs_appid': [{
					required: false,
					message: '请填写小程序appid',
					trigger: 'blur'
				}],
				'stock_send_rule.mini_programs_path': [{
					required: false,
					message: '请填写小程序path',
					trigger: 'blur'
				}],
			},
			type: 0
		}
	},
	watch:{
		'formList.stock_send_rule.max_coupons_per_user'(val){
			console.log(val)
			if(val>100){
				this.formList.stock_send_rule.max_coupons_per_user=100
			}
		}
	},
	mounted() {
		if(this.$datas.couponPackage.id){
			this.id = this.$datas.couponPackage.id;
			if (this.$datas.couponPackage.couponsRule) {
				this.formList = this.$datas.couponPackage.couponsRule;
				this.t1 = this.formList.coupon_use_rule.coupon_available_time.available_begin_time.slice(0, 19).replace('T', ' ');
				this.t2 = this.formList.coupon_use_rule.coupon_available_time.available_end_time.slice(0, 19).replace('T', ' ');
			}
		}else {
			this.cancel();
		}

	},
	methods: {
		stockSelect() {
			// console.log(this.formList.stock_type)
		},
		changeMethod() {
			if(this.formList.coupon_use_rule.use_method==='MINI_PROGRAMS'){
				this.rules['stock_send_rule.mini_programs_appid'][0].required=true;
				this.rules['stock_send_rule.mini_programs_path'][0].required=true;
			}else{
				this.rules['stock_send_rule.mini_programs_appid'][0].required=false;
				this.rules['stock_send_rule.mini_programs_path'][0].required=false;
			}
		},
		changeTime(val) {
			if (this.t2 === '') {
				this.t2 = this.t1;
				this.formList.coupon_use_rule.coupon_available_time.available_end_time = this.formatDate(val);
			}
			this.formList.coupon_use_rule.coupon_available_time.available_begin_time = this.formatDate(val);
		},
		changeTime2(val) {
			this.formList.coupon_use_rule.coupon_available_time.available_end_time = this.formatDate(val);
		},
		formatDate(str) {
			if (str === '') {
				return '';
			}
			let arr = str.split(' ').join('T');
			return arr + '+08:00';
		},
		//查看大图
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		save() {//保存
			let form = Object.assign({}, this.formList);
			this.$refs.formList.validate((valid) => {
				if (valid) {
					let data = {
						id: this.id,
						max_package: form.stock_send_rule.max_coupons_per_user,
            available_begin_time: this.t1,
            available_end_time: this.t2,
						max_coupons_per_user: form.stock_send_rule.max_coupons_per_user,
						max_coupons_by_day: form.stock_send_rule.max_coupons_by_day ? form.stock_send_rule.max_coupons_by_day : 0,
						coupons_common_rule: JSON.stringify(form)
					};
					coupon.updateCouponPackage(data).then(res => {
						this.cancel();
					})
				}
			})
		},
		cancel() {
			this.$router.push({
				path: "/couponPackage"
			});
		},
		upLoadSuccessLogo(res, file) {//上传logo
			if (res.code === 0) {
				this.formList.display_pattern_info.merchant_logo_url = JSON.parse(res.data).media_url;
			}
		},
	},
}
</script>

<style>
p span {
	margin: 0 25px;
}

.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 178px;
	height: 178px;
	line-height: 178px;
	text-align: center;
}

.avatar {
	width: 178px;
	height: 178px;
	display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/couponSetting.vue